import { h, Fragment } from 'preact';
import IntervalTree from '@flatten-js/interval-tree';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';
import { PopAnnotation } from 'rendering/annotations/pop';

export class VideoText extends BaseAnnotation {
    constructor(props) {
        super(props);
        this.initRanges();
    }

    componentDidUpdate() {
        const { lastModified } = this.props;
        if (lastModified > this.rangeGenerated) {
            this.initRanges();
        }
    }

    initRanges() {
        this.videoTextRanges = new IntervalTree();

        const { id, start, end } = this.options;

        for (let index in id) {
            this.videoTextRanges.insert([
                start[index],
                end[index]
            ], index);
        }

        this.rangeGenerated = this.props.lastModified;
    }

    get activeText() {
        const { currentTime } = this.props;
        const { id, content, styles, animation } = this.options;
        const globalStyles = {};

        if (this.languageHidden) {
            globalStyles.backgroundColor = 'transparent';
            globalStyles.color = 'transparent';
        }

        const searchTime = currentTime < 0 ? 0 : currentTime;

        return (
            this.videoTextRanges.search([searchTime,searchTime], index => {
                const attrs = {
                    currentTime,
                    key: `annotation-videotext-${id[index]}`,
                    content: content[index],
                    styles: { ...styles[index], ...globalStyles  },
                    animation: animation[index],
                    properties: {
                        fitTextToContainer: true,
                        localized: true
                    }
                };

                return <PopAnnotation {...attrs} />
            })
        )
    }

    get currentLanguage() {
        const { state = {} } = this.props.data;
        return state.language;
    }

    get languageHidden() {
        if (this.options.languageVisibility) {
            return !this.options.languageVisibility[this.currentLanguage];
        }

        return false;
    }

    render() {
        return <Fragment>{this.activeText}</Fragment>
    }
}